enum BookingStatus {
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  AWAITING_PAYMENT = 'awaiting_payment',
  UNKNOWN_DEPOSIT = 'unknown_deposit',
}

export default BookingStatus
